<template>
  <div class="penalty-points-page">
    <AppBreadcrumb :items="breadcrumbItems" :showBack="true" @back="goBack" />
    
    <div class="page-header">
      <h1 class="page-title">Ma'muriy javobgarlik to'g'risidagi kodeks</h1>
      <p class="page-subtitle">Jarima ballari hisoblanishi belgilangan moddalar</p>
    </div>

    <div class="stats-cards">
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalArticles }}</div>
          <div class="stat-label">Moddalar soni</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12V8H4V12M20 12L4 12M20 12L22 18H2L4 12M20 12H22M4 12H2M12 8V12" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="12" cy="16" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalParts }}</div>
          <div class="stat-label">Qismlar soni</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H21M6 6V4M18 6V4M5 10H19M7 14H17M9 18H15" stroke="currentColor" stroke-width="1.5"/>
            <rect x="4" y="6" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ maxPoints }}</div>
          <div class="stat-label">Eng yuqori ball</div>
        </div>
      </div>
    </div>

    <div class="articles-list">
      <div 
        v-for="article in articles" 
        :key="article.number"
        class="article-card"
        :class="{ expanded: expandedArticle === article.number }"
      >
        <div class="article-header" @click="toggleArticle(article.number)">
          <div class="article-number">
            <span class="number">{{ article.number }}-modda</span>
            <span class="title">{{ article.title }}</span>
          </div>
          <div class="article-actions">
            <svg 
              class="expand-icon" 
              :class="{ rotated: expandedArticle === article.number }"
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none"
            >
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </div>

        <div v-show="expandedArticle === article.number" class="article-content">
          <div 
            v-for="(part, index) in article.parts" 
            :key="index"
            class="part-item"
            :class="getPartClass(part.points)"
          >
            <div class="part-header">
              <div class="part-number">
                <span v-if="article.parts.length > 1">{{ getPartText(index) }}</span>
                <span v-else>Asosiy qism</span>
              </div>
              <div class="points-badge" :class="getPointsClass(part.points)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z" fill="currentColor"/>
                </svg>
                <span>{{ part.points }} ball</span>
              </div>
            </div>
            <p class="part-description">{{ part.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="info-note">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8V12M12 16H12.01M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      <div class="note-content">
        <strong>Eslatma:</strong> Jarima ballari ma'muriy javobgarlik to'g'risidagi kodeksning tegishli moddalariga asosan hisoblanadi. Ballar yig'indisi 12 balldan oshganda haydovchilik guvohnomasi olib qo'yiladi.
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'

export default {
  name: 'PenaltyPointsView',
  components: { AppBreadcrumb },

  data() {
    return {
      expandedArticle: null,
      articles: [
        {
          number: 125,
          title: 'Transport vositalaridan foydalanish qoidalarini buzish',
          parts: [
            {
              points: 0.3,
              description: 'Haydovchilarning tormoz tizimida, rul boshqaruvida yoki ulovchi qurilmada nosozligi boʻlgan yoxud tegishli ruxsatnomasiz qayta jihozlangan transport vositalarini boshqarishi'
            },
            {
              points: 1,
              description: 'Foydalanish belgilangan tartibda man etilgan transport vositalarini, xuddi shuningdek davlat raqam belgisi oʻzboshimchalik bilan yechib olingan transport vositalarini boshqarish'
            }
          ]
        },
        {
          number: 126,
          title: "Koʻzgusimon va (yoki) tusi oʻzgartirilgan (qoraytirilgan) oynali, shuningdek tevarak-atrofni koʻrishni cheklaydigan qoplamali transport vositalaridan foydalanish",
          parts: [
            {
              points: 0.5,
              description: 'Texnik reglamentga muvofiq boʻlmagan koʻzgusimon va (yoki) tusi oʻzgartirilgan (qoraytirilgan) oynali transport vositalaridan, xuddi shuningdek haydovchining oʻrnidan tevarak-atrofni koʻrishni cheklaydigan qoʻshimcha narsalar oʻrnatilgan yoki qoplamalar surtilgan transport vositalaridan foydalanish, bundan oynalar tusini oʻzgartirish (qoraytirish) uchun tegishli ruxsatnoma berilgan transport vositalari mustasno'
            },
            {
              points: 1,
              description: 'Xuddi shunday huquqbuzarlik maʼmuriy jazo chorasi qoʻllanilganidan keyin bir yil davomida takror sodir etilgan boʻlsa'
            }
          ]
        },
        {
          number: 127,
          title: 'Transport vositalarining tovush chiqaruvchi, yorituvchi va boshqa qurilmalaridan foydalanish, ularni oʻrnatish qoidalarini buzish',
          parts: [
            {
              points: 0.2,
              description: 'Tovush signalini sababsiz berish, transport vositalariga uni ishlab chiqargan korxona nazarda tutmagan tovush chiqaruvchi va yorituvchi qurilmalarni oʻrnatish, xuddi shuningdek ularni oʻzgartirib oʻrnatish'
            }
          ]
        },
        {
          number: 1283,
          title: 'Transport vositalari haydovchilarining belgilangan harakat tezligini oshirib yuborishi',
          parts: [
            { points: 0.5, description: 'Belgilangan harakat tezligini soatiga 20 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 1, description: 'Belgilangan harakat tezligini soatiga 20 kilometrdan ortiq, lekin 40 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 1.5, description: 'Belgilangan harakat tezligini soatiga 40 kilometrdan ortiq, lekin 60 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 2, description: 'Belgilangan harakat tezligini soatiga 60 kilometrdan ortiq kattalikda oshirib yuborishi' }
          ]
        },
        {
          number: 1284,
          title: "Transport vositalari haydovchilarining svetoforning taqiqlovchi signaliga yoki yoʻl harakatini tartibga soluvchining taqiqlovchi ishorasiga boʻysunmasdan toʻxtash chizigʻini bosib kirishi va oʻtishi",
          parts: [
            { points: 1, description: 'Svetoforning taqiqlovchi signaliga yoki yoʻl harakatini tartibga soluvchining taqiqlovchi ishorasiga boʻysunmasdan oʻtishi' }
          ]
        },
        {
          number: 1285,
          title: "Transport vositalari haydovchilarining xalaqit berishi yoki avariya holatini yuzaga keltirishi, yoʻlning qarama-qarshi harakatlanish uchun moʻljallangan tomoniga yoki boʻlagiga chiqishi",
          parts: [
            { points: 0.5, description: "Tezkor va maxsus xizmatlarning koʻk yoki qizil yoxud koʻk va qizil rangli yaltiroq mayoqchani yoqqan holda hamda maxsus tovushli signal bilan yaqinlashib kelayotgan transport vositalari toʻsiqsiz oʻtib ketishi uchun transport vositalari haydovchilari tomonidan xalaqit berish" },
            { points: 1, description: "Yoʻlning qarama-qarshi harakatlanish uchun moʻljallangan tomoniga yoki boʻlagiga yoʻl harakati qoidalarini buzgan holda chiqishi, xuddi shuningdek avariya holati yuzaga kelishiga sabab boʻlgan, yaʼni yoʻl harakatining boshqa qatnashchilarini tezlikni, harakat yoʻnalishini keskin oʻzgartirishga yoki oʻz xavfsizligini yoxud boshqa fuqarolarning xavfsizligini taʼminlash uchun oʻzga choralarni koʻrishga majbur qiluvchi huquqbuzarlikni sodir etishi" }
          ]
        },
        {
          number: 1286,
          title: "Transport vositalari haydovchilarining toʻxtash yoki toʻxtab turish qoidalarini buzishi",
          parts: [
            { points: 0.2, description: "Toʻxtash yoki toʻxtab turish qoidalarini buzishi" }
          ]
        },
        {
          number: 1288,
          title: "Transport vositasida odam tashish qoidalarini buzish",
          parts: [
            { points: 0.3, description: "Odam tashish qoidalarini buzish" },
            { points: 0.5, description: "Avtobus va mikroavtobuslarda ichki ishlar organlarining hamrohligisiz odam tashish, agar ularning hamrohligida odam tashish shart boʻlsa" }
          ]
        },
        {
          number: 1289,
          title: "Transport vositalarini quvib oʻtish qoidalarini buzish",
          parts: [
            { points: 1, description: "Quvib oʻtish qoidalarini buzish" }
          ]
        },
        {
          number: 129,
          title: "Transport vositalari haydovchilarining yoʻl harakati xavfsizligiga tahdid soluvchi guruh boʻlib harakat qilishda qatnashishi",
          parts: [
            { points: 1.5, description: "Yoʻl harakati xavfsizligiga tahdid soluvchi yoki avariya holatini keltirib chiqaruvchi guruh boʻlib harakat qilishda qatnashishi" }
          ]
        },
        {
          number: 130,
          title: "Transport vositalari haydovchilarining temir yoʻlning oʻtish joylaridan oʻtish qoidalarini buzishi",
          parts: [
            { points: 1, description: "Temir yoʻlning oʻtish joylaridan oʻtish qoidalarini buzishi" }
          ]
        },
        {
          number: 137,
          title: "Yoʻl-transport hodisasi yuz bergan joydan ketib qolish",
          parts: [
            { points: 2, description: "Yoʻl-transport hodisasi qatnashchilarining belgilangan qoidalarni buzgan holda hodisa yuz bergan joydan ketib qolishi" }
          ]
        }
      ]
    }
  },

  computed: {
    breadcrumbItems() {
      return [{ label: 'Jarima ballari' }]
    },

    totalArticles() {
      return this.articles.length
    },

    totalParts() {
      return this.articles.reduce((sum, article) => sum + article.parts.length, 0)
    },

    maxPoints() {
      let max = 0
      this.articles.forEach(article => {
        article.parts.forEach(part => {
          if (part.points > max) max = part.points
        })
      })
      return max
    }
  },

  methods: {
    toggleArticle(number) {
      this.expandedArticle = this.expandedArticle === number ? null : number
    },

    getPartText(index) {
      const texts = ['Birinchi qism', 'Ikkinchi qism', 'Uchinchi qism', 'Toʻrtinchi qism', 'Beshinchi qism']
      return texts[index] || `${index + 1}-qism`
    },

    getPointsClass(points) {
      if (points >= 1.5) return 'points-high'
      if (points >= 1) return 'points-medium'
      if (points >= 0.5) return 'points-low'
      return 'points-minimal'
    },

    getPartClass(points) {
      if (points >= 1.5) return 'part-high'
      if (points >= 1) return 'part-medium'
      if (points >= 0.5) return 'part-low'
      return 'part-minimal'
    },

    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.penalty-points-page {
  min-height: 100vh;
  padding: 20px;
  background: var(--bg);
}

@media (max-width: 768px) {
  .penalty-points-page {
    padding: 12px;
  }
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 22px;
  }
}

.page-subtitle {
  font-size: 16px;
  color: var(--text-soft);
}

@media (max-width: 768px) {
  .page-subtitle {
    font-size: 14px;
  }
}

/* Stats Cards */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

@media (max-width: 768px) {
  .stats-cards {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .stats-cards {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.stat-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 16px;
  color: var(--primary);
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 32px;
  font-weight: 800;
  color: var(--text);
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  color: var(--text-soft);
  margin-top: 6px;
}

@media (max-width: 768px) {
  .stat-card {
    padding: 16px;
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
  }
  
  .stat-value {
    font-size: 26px;
  }
  
  .stat-label {
    font-size: 12px;
  }
}

/* Articles List */
.articles-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.article-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.article-card:hover {
  border-color: var(--primary);
}

.article-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.article-header:hover {
  background: rgba(59, 130, 246, 0.05);
}

.article-number {
  flex: 1;
}

.number {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary);
  display: inline-block;
  margin-right: 12px;
}

.title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
}

@media (max-width: 768px) {
  .article-header {
    padding: 14px 16px;
  }
  
  .number {
    font-size: 14px;
    display: block;
    margin-bottom: 6px;
  }
  
  .title {
    font-size: 14px;
    display: block;
  }
}

.expand-icon {
  transition: transform 0.3s ease;
  color: var(--text-soft);
}

.expand-icon.rotated {
  transform: rotate(180deg);
}

.article-content {
  padding: 0 20px 20px 20px;
  border-top: 1px solid var(--border);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.part-item {
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}

.part-item:last-child {
  margin-bottom: 0;
}

.part-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 10px;
}

.part-number {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.points-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.points-badge svg {
  width: 14px;
  height: 14px;
}

.points-badge.points-high {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.points-badge.points-medium {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.points-badge.points-low {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.points-badge.points-minimal {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.part-description {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-soft);
  margin: 0;
}

.part-high {
  border-left: 3px solid #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.part-medium {
  border-left: 3px solid #f59e0b;
  background: rgba(245, 158, 11, 0.05);
}

.part-low {
  border-left: 3px solid #22c55e;
  background: rgba(34, 197, 94, 0.05);
}

.part-minimal {
  border-left: 3px solid #3b82f6;
  background: rgba(59, 130, 246, 0.05);
}

@media (max-width: 768px) {
  .article-content {
    padding: 0 16px 16px 16px;
  }
  
  .part-item {
    padding: 12px;
  }
  
  .part-number {
    font-size: 12px;
  }
  
  .points-badge {
    font-size: 12px;
    padding: 3px 10px;
  }
  
  .part-description {
    font-size: 13px;
  }
}

/* Info Note */
.info-note {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  margin-top: 20px;
}

.info-note svg {
  color: var(--primary);
  flex-shrink: 0;
}

.note-content {
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-soft);
}

.note-content strong {
  color: var(--primary);
}

@media (max-width: 768px) {
  .info-note {
    padding: 14px 16px;
  }
  
  .note-content {
    font-size: 13px;
  }
}
</style>